<template>
  <div :class="`teaor-selector ${this.showError ? 'error-border' : ''}`">
    <vue-autosuggest
      :suggestions="[
        {
          data: teaorList.filter(el => el.labelText.toLowerCase().includes(filterText.toString()))
        }
      ]"
      :input-props="{ type: 'search', id: 'autosuggest__input', placeholder: 'TEAOR kód kiválasztása', disabled }"
      :get-suggestion-value="getSuggestionValue"
      @input="onInputChange"
      @selected="selectHandler"
      ref="autosuggestRef"
    >
      <template slot-scope="{ suggestion }">
        <span class="my-suggestion-item">{{ suggestion.item.labelText }} </span>
      </template>
    </vue-autosuggest>
    <p v-show="this.showError" class="error-message">
      Válassza ki a tevékenységi kört
    </p>
  </div>
</template>

<script>
import teaorList from './teaor'
import { VueAutosuggest } from 'vue-autosuggest'
import twoDigitTeaors from './separatedTeaors/twoDigitTeaors'
import threeDigitTeaors from './separatedTeaors/threeDigitTeaors'
import fourDigitTeaors from './separatedTeaors/fourDigitTeaors'
export default {
  data() {
    return {
      teaorList:
        this.listType === 'twoDigit'
          ? twoDigitTeaors
          : this.listType === 'threeDigit'
          ? threeDigitTeaors
          : this.listType === 'fourDigit'
          ? fourDigitTeaors
          : teaorList,
      filterText: ''
    }
  },
  props: {
    disabled: { type: Boolean },
    alreadySelected: { type: String },
    showError: { type: Boolean },
    listType: {
      type: String,
      validator: prop => ['twoDigit', 'threeDigit', 'fourDigit'].includes(prop)
    }
  },
  components: {
    VueAutosuggest
  },
  methods: {
    onInputChange(text) {
      this.filterText = text
    },
    selectHandler(suggestion) {
      this.$emit('selected-teaor', suggestion.item.teaorValue)
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.labelText
    }
  },
  watch: {
    disabled() {
      if (this.disabled) {
        this.$refs.autosuggestRef.internalValue = ''
      }
    }
  },
  mounted() {
    if (this.alreadySelected !== '') {
      const teaorFound = this.teaorList.find(item => item.teaorValue === this.alreadySelected.toString())
      this.$refs.autosuggestRef.internalValue = teaorFound.labelText
      this.$refs.autosuggestRef.searchInputOriginal = teaorFound.labelText
      this.$refs.autosuggestRef.didSelectFromOptions = true
    }
  }
}
</script>

<style>
.teaor-selector .autosuggest__results {
  overflow: auto;
}

.teaor-selector #autosuggest__input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 2px solid #b2bec3;
  max-height: 50px;
  border-radius: 4px;
  font-size: 16px;
  color: black !important;
}

#autosuggest__input::placeholder {
  color: #636e72 !important;
}

.teaor-selector #autosuggest__input.autosuggest__input--open {
  border: 1px solid #00903c;
}

.error-border #autosuggest__input {
  border: 2px solid #ba3b46 !important;
}

.error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 12px;
}

@media all and (max-width: 993px) {
  .autosuggest__results-item {
    font-size: 12px;
  }
}
</style>
